import axios from '../api/index'
export const getAuthorities = async () =>{
    return await axios.request('get',`/jobs`)
        .then(res => Promise.resolve(res.data))
}